export class OrderedOptionUI {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get option() {
        return this.parent;
    }
    get hasFailedToSelectInAtLeastOneStep() {
        return !!this.option.task.steps.find(step => step.stepEval.isFailed && step.correctOption === this.option);
    }
    get shouldHideBecauseOfFailed() {
        return this.hasFailedToSelectInAtLeastOneStep && !this.option.task.taskProgress.isTaskCompleted;
    }
    get shouldShowTemporaryFalseFeedback_1500ms() {
        if (!this.option.task.step)
            return false;
        return (this.option.task.step.stepUI.shouldShowTemporaryFalseFeedback_1500ms &&
            this.option.task.step.stepState.latestSelectedOption === this.option);
    }
    get shouldShowTemporaryCorrectFeedback_500ms() {
        if (!this.option.task.latestCompletedStep)
            return false;
        const step = this.option.task.latestCompletedStep;
        if (step.stepState.latestSelectedOption !== this.option)
            return false;
        if (!step.stepState.latestSelectionEvent)
            return false;
        if (this.option.context.app.appClock.clock_250.tickingTime > step.stepState.latestSelectionEvent.appTime + 500) {
            return false;
        }
        return true;
    }
}
